/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum YesNoMaybe {
  Yes = "Yes",
  Maybe = "Maybe",
  No = "No",
}

export const YesNoMaybeDisplay: Record<YesNoMaybe, string> = {
  [YesNoMaybe.Yes]: "Yes",
  [YesNoMaybe.Maybe]: "Maybe",
  [YesNoMaybe.No]: "No",
};
